import { render, staticRenderFns } from "./youxiang.vue?vue&type=template&id=bc397906&scoped=true&"
import script from "./youxiang.vue?vue&type=script&lang=js&"
export * from "./youxiang.vue?vue&type=script&lang=js&"
import style0 from "./youxiang.vue?vue&type=style&index=0&id=bc397906&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc397906",
  null
  
)

export default component.exports